import React, {  } from "react";
import { Modal,  Form } from "antd";
import SecondaryButton from "../../Button/SecondaryButton";

import { Puff } from "react-loader-spinner";
import TextAreaInput from "../../ReusableInputs/TextAreaInput";

const Loader: React.FC = () => {
  return (
    <div className="flex items-left justify-left ">
      <Puff
        visible={true}
        height="60"
        width="60"
        color="#75A7AD"
        ariaLabel="puff-loading"
      />
    </div>
  );
};

export const SpecialInstructionModal: React.FC<{
  isProcessing: boolean;
  special_instruction: string;
  isInstructionModal: boolean;
  setSpecialInstruction: (value:string) => void;
  handleUpdateNote: () => void;
  handleOpenInstructionModal: () => void;
  address?: {
    address_1: string;
    special_instruction?: string;
  } | null;
  onClose: () => void;
}> = ({
  isInstructionModal,
  setSpecialInstruction,
  special_instruction,
  onClose,
  handleUpdateNote,
  isProcessing,
  address,

  handleOpenInstructionModal,
}) => {
  const [form] = Form.useForm();

  return (
    <Modal
      title="Special Instructions"
      open={isInstructionModal}
      onCancel={onClose}
      footer={null}>
      <Form onFinish={handleUpdateNote}>
       <TextAreaInput title="Special Instruction (Notes)" placeholder="Enter Instruction" 
       inputValue={special_instruction} setInputValue={setSpecialInstruction}/>
        <section className="text-center mt-4">
          {isProcessing ? (
            <Loader />
          ) : (
            <SecondaryButton
              onClick={() => form.submit()}
              label={
                address?.special_instruction
                  ? "Update Instruction"
                  : "Add Instruction"
              }
            />
          )}
        </section>
      </Form>
    </Modal>
  );
};
